
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

console.log(process.env);
console.log(process.env.MIX_APP_URL);

window.Vue = require('vue').default;

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import locale from 'element-ui/lib/locale/lang/en'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

if (process.env.MIX_APP_URL === 'https://chimera.davidhobbsconsulting.com') {
    Sentry.init({
        dsn: 'https://42ad8267b43348839941a31f83fc5afc@sentry.io/1475987',
        release: GIT_HASH,
        integrations: [new Integrations.Vue({Vue, attachProps: true})],
    });
}

Vue.use(ElementUI, { locale })

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('tour-manager',require('./components/Tour/TourManager').default);

Vue.component('example-component', require('./components/old/ExampleComponent.vue').default);
Vue.component('tenant-list', require('./components/TenantList.vue').default);
Vue.component('tenant-input', require('./components/TenantInput.vue').default);
Vue.component('data-import-input', require('./components/Assets/DataImportInput.vue').default);
Vue.component('rot-analysis-input', require('./components/Assets/RotAnalysisInput.vue').default);

Vue.component('list-fields-ca', require('./components/ListFieldsCA.vue').default);
Vue.component('ca-fields-scatter', require('./components/CAFieldsScatter.vue').default);

Vue.component('gallery', require('./components/Gallery.vue').default);

Vue.component('quiz',require('./components/Quiz/Quiz.vue').default);
Vue.component('size-calculator',require('./components/Quiz/SizeCalculator.vue').default);

Vue.component('table-view',require('./components/Table/TableView.vue').default);
Vue.component('asset-table-view',require('./components/Table/AssetTableView.vue').default);

Vue.component('pricing',require('./components/Pricing.vue').default);
Vue.component('pricing_card',require('./components/PricingCard.vue').default);

Vue.component('social-share',require('./components/SocialShare.vue').default);
Vue.component('target-list',require('./components/TargetList.vue').default);


Vue.component('progress-list', require('./components/Progress/ProgressList.vue').default);
Vue.component('progress-display', require('./components/Progress/ProgressCircles.vue').default);
Vue.component('AfterDataImport', require('./components/Progress/AfterDataImport.vue').default);
Vue.component('AfterAssignment', require('./components/Progress/AfterAssignment.vue').default);
Vue.component('crawl_errors', require('./components/Progress/CrawlErrors.vue').default);

Vue.component('annotation', require('./components/Assets/Annotation.vue').default);
Vue.component('annotation-list', require('./components/Assets/AnnotationList.vue').default);
Vue.component('image-list', require('./components/ImageList.vue').default);

Vue.component('assets-page', require('./components/Assets/AssetsPage.vue').default);
Vue.component('merge-metadata', require('./components/Assets/MergeMetadata.vue').default);
Vue.component('scrape', require('./components/Assets/Scrape.vue').default);
Vue.component('crawl', require('./components/Assets/Crawl.vue').default);
Vue.component('easy-crawl', require('./components/EasyCrawl.vue').default);
Vue.component('llm-chat-crawl', require('./components/LLM/LlmChatCrawl.vue').default);
Vue.component('AssetDetails', require('./components/Assets/AssetDetails.vue').default);
Vue.component('manual-field-editor', require('./components/Assets/ManualFieldEditor.vue').default)
Vue.component('FullPatternEditor',require('./components/Patterns/FullPatternEditor.vue').default);
Vue.component('PatternEditor',require('./components/Patterns/PatternEditor.vue').default);
Vue.component('PatternEditorStandard',require('./components/Patterns/PatternEditorStandard.vue').default);
Vue.component('ScopeEditor',require('./components/Patterns/ScopeEditor.vue').default);
Vue.component('ScopeEditorStandard',require('./components/Patterns/ScopeEditorStandard.vue').default);
Vue.component('PatternTryResults',require('./components/Patterns/PatternTryResults.vue').default);
// data-source-editor was the start of a totally-custom component for doing an arbitrary import
// DataSourceEditorStandard is a simplified source editor using StandardForm/FormManager
Vue.component('data-source-editor',require('./components/Assets/DataSourceEditor.vue').default);
Vue.component('DataSourceEditorStandard',require('./components/Assets/DataSourceEditorStandard.vue').default);
Vue.component('manage-data-sources', require('./components/Assets/ManageDataSources.vue').default);
Vue.component('job-chain-start-button', require('./components/JobChainStartButton.vue').default);
Vue.component('filters', require('./components/Assets/Filters.vue').default);


Vue.component('user-extents-status',require('./components/Progress/UserExtentsStatus.vue').default);
Vue.component('user-history',require('./components/UserAndAccount/UserHistory.vue').default);
Vue.component('extent-history',require('./components/UserAndAccount/ExtentHistory.vue').default);
Vue.component('extent-details',require('./components/ExtentDetails.vue').default);
Vue.component('activity-list',require('./components/UserAndAccount/ActivityList.vue').default);
Vue.component('billing-and-users',require('./components/UserAndAccount/BillingAndUsers.vue').default);
Vue.component('payment-method',require('./components/UserAndAccount/PaymentMethod.vue').default);
Vue.component('timezone',require('./components/UserAndAccount/Timezone.vue').default);
Vue.component('presence',require('./components/UserAndAccount/Presence').default);
Vue.component('organizations-status',require('./components/UserAndAccount/OrganizationsStatus').default);


Vue.component('ExtentList', require('./components/ExtentSelectionAndPersistence/ExtentList.vue').default);
Vue.component('rule-set-old', require('./components/Rules/RuleSetOld.vue').default);
Vue.component('rule-set', require('./components/Rules/RuleSet.vue').default);
Vue.component('rule-set-simple', require('./components/Rules/RuleSetSimple.vue').default);
Vue.component('assignments', require('./components/Assignments.vue').default);

Vue.component('filter-edit', require('./components/AssetFilterEdit.vue').default);

Vue.component('ChartPie', require('./components/DataExploration/ChartPie.vue').default);
Vue.component('ChartBar', require('./components/DataExploration/ChartBar.vue').default);
Vue.component('ChartScatter', require('./components/DataExploration/ChartScatter.vue').default);
Vue.component('ChartSankey', require('./components/DataExploration/ChartSankey.vue').default);
Vue.component('TableHeatmap', require('./components/DataExploration/TableHeatmap.vue').default);
Vue.component('TableCustom', require('./components/DataExploration/TableCustom.vue').default);
Vue.component('TableCustomEditableCell', require('./components/DataExploration/TableCustomEditableCell.vue').default);
Vue.component('TableHeatmapCell', require('./components/DataExploration/TableHeatmapCell.vue').default);
Vue.component('ChartManager', require('./components/DataExploration/ChartManager.vue').default);
Vue.component('TableSample', require('./components/DataExploration/TableSample.vue').default);
Vue.component('SingleFieldBarChart', require('./components/DataExploration/SingleFieldBarChart.vue').default);
Vue.component('ReportCompVisualFilter', require('./components/DataExploration/ReportCompVisualFilter.vue').default);
Vue.component('CrawlTimeSeries', require('./components/DataExploration/CrawlTimeSeries.vue').default);
Vue.component('ChartTimeSeries', require('./components/DataExploration/ChartTimeSeries.vue').default);
Vue.component('BigNumber', require('./components/DataExploration/BigNumber.vue').default);
Vue.component('WordCloud', require('./components/DataExploration/WordCloud.vue').default);
Vue.component('ChartProportionalArea', require('./components/DataExploration/ChartProportionalArea.vue').default);
Vue.component('ChartStellar', require('./components/DataExploration/ChartStellar.vue').default);
Vue.component('ChartSitemap', require('./components/DataExploration/ChartSitemap.vue').default);
Vue.component('group-labels', require('./components/DataExploration/GroupLabels.vue').default);
Vue.component('Report', require('./components/DataExploration/Report.vue').default);
Vue.component('ReportComp', require('./components/DataExploration/ReportComp.vue').default);
Vue.component('ReportCompSingle', require('./components/DataExploration/ReportCompSingle.vue').default);
Vue.component('ReportCompImage', require('./components/DataExploration/ReportCompImage.vue').default);
Vue.component('ReportCompSectionBreak', require('./components/DataExploration/ReportCompSectionBreak.vue').default);
Vue.component('ReportCompSmallMult', require('./components/DataExploration/ReportCompSmallMult.vue').default);
Vue.component('user-reports', require('./components/UserAndAccount/UserReports').default);
Vue.component('NetworkTimeline', require('./components/DataExploration/NetworkTimeline.vue').default);

Vue.component('free-discovery-start', require('./components/DiscoveryForFree/StartCrawl.vue').default);
Vue.component('free-work', require('./components/DiscoveryForFree/Work.vue').default);
Vue.component('percentage-assign', require('./components/DiscoveryForFree/PercentageAssign.vue').default);
Vue.component('implications', require('./components/DiscoveryForFree/Implications.vue').default);

Vue.component('words-ignore', require('./components/ROT/WordsIgnore.vue').default);

Vue.component('FormManager', require('./components/StandardForm/FormManager').default);
Vue.component('FormElementBoolean', require('./components/StandardForm/FormElementBoolean').default);
Vue.component('FormElementRadio', require('./components/StandardForm/FormElementRadio').default);
Vue.component('FormElementInteger', require('./components/StandardForm/FormElementInteger').default);
Vue.component('FormElementList', require('./components/StandardForm/FormElementList').default);
Vue.component('FormElementShortText', require('./components/StandardForm/FormElementShortText').default);
Vue.component('FormElementLongText', require('./components/StandardForm/FormElementLongText').default);
Vue.component('FormElementGeneric', require('./components/StandardForm/FormElementGeneric').default);
Vue.component('FormElementImage', require('./components/StandardForm/FormElementImage').default);
Vue.component('FormJson', require('./components/StandardForm/FormJson').default);

Vue.component('llm-prompt-field', require('./components/LLM/LlmPromptField').default);
Vue.component('llm-prompt-fieldset', require('./components/LLM/LlmPromptFieldset').default);
Vue.component('llm-prompt-fieldsets-index', require('./components/LLM/LlmPromptFieldsetsIndex').default);
Vue.component('llm-chat', require('./components/LLM/LlmChat.vue').default);
Vue.component('sampling-definition', require('./components/Sampling/SamplingDefinition').default);
Vue.component('sampling-definitions-index', require('./components/SamplingDefinitionsIndex').default);

Vue.component('map-index', require('./components/Mappings/MapIndex').default);
Vue.component('map-pair-editor', require('./components/Mappings/MapPairEditor').default);
Vue.component('category-field-set', require('./components/Categories/CategoryFieldSet').default);
Vue.component('ReferralCodes', require('./components/ReferralCodes').default);
Vue.component('versioned-text',  require('./components/VersionedText').default);
Vue.component('MetadataViewer', require('./components/Assets/MetadataViewer.vue').default);
Vue.component('encountered-domains', require('./components/EncounteredDomains.vue').default);
Vue.component('list-compare', require('./components/Assets/ListCompare.vue').default);
Vue.component('list-tables', require('./components/Assets/ListTables.vue').default);
Vue.component('dispositions', require('./components/Dispositions/Dispositions.vue').default);
Vue.component('formula-editor',require('./components/Assets/FormulaEditor.vue').default);

Vue.component('asset-page-router-wrapper', require('./components/AssetPageRouterWrapper.vue').default);

$(function() {
    $('.toggle-advanced').on('click', function () {
        $('#advanced').toggle();
    });
    $('#link-names').on('click', function () {
        $('#names').toggle();
    });
});

import VueRouter from 'vue-router';

const AssetsPage = require('./components/Assets/AssetsPage.vue').default;

const router = new VueRouter({
    'mode': 'history',
    routes: [
        { path: '*', component: AssetsPage}
    ]
});

Vue.use(VueRouter);

const app = new Vue({
    el: '#app',
    router
});
